module.exports = __webpack_public_path__ + "img/sweden-neoplasm-female.d4bd7211.png";